var React = require('react');

function Reload (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.5 10.833a7.5 7.5 0 0 1 7.5-7.5A.833.833 0 0 1 10 5a5.833 5.833 0 1 0 5.833 5.833.833.833 0 1 1 1.667 0 7.5 7.5 0 0 1-15 0z","fill":"red","key":0}),React.createElement("path",{"d":"M10.98 1.304a.625.625 0 0 0-.98.514v5.114c0 .504.566.801.98.514l3.694-2.557a.625.625 0 0 0 0-1.028l-3.693-2.557z","fill":"red","key":1})]);
}

Reload.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Reload;

Reload.default = Reload;
